import { SVGProps } from 'react';

const SvgRadioUnchecked = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
        <rect width={19} height={19} x={0.5} y={0.5} rx={9.5} />
        <rect width={19} height={19} x={0.5} y={0.5} rx={9.5} />
    </svg>
);
export default SvgRadioUnchecked;
